<div class="trigger-container">
    <span class="body-medium" [innerHTML]="sanitizedTitle"></span>
    <ion-item
        [button]="!disabled"
        detail="false"
        lines="none"
        [id]="'trigger' + field"
        [class.error]="error"
        [class.disabled]="disabled"
    >
        <ion-label class="body-medium">{{ buttonText() }}</ion-label>
        <ion-icon src="assets/icon/chevron-down.svg" slot="end" [class.disabled-icon]="disabled"> </ion-icon>
    </ion-item>
</div>

<ion-modal
    [trigger]="disabled ? undefined : 'trigger' + field"
    #modal
    class="modal-item-picker"
    [initialBreakpoint]="0.9"
    [breakpoints]="[0, 0.9]"
    [expandToScroll]="false"
>
    <ng-template>
        <ion-header>
            <ion-toolbar mode="ios">
                <ion-buttons slot="start">
                    <ion-button (click)="cancelChanges()">{{ 'GLOBAL.FORM.CANCEL' | translate }}</ion-button>
                </ion-buttons>
                <ion-title class="sub-headline-bold">{{ title }}</ion-title>
            </ion-toolbar>
            @if (items.length > 10) {
                <ion-toolbar mode="ios" style="--padding-start: 0.8rem; --padding-end: 0.8rem">
                    <web-input (input)="searchbarInput($event)" icon="search.svg" iconPosition="end"></web-input>
                </ion-toolbar>
            }
        </ion-header>

        <ion-content style="--padding-top: 0.8rem; --padding-bottom: 2.4rem">
            <ion-list id="modal-list" lines="none">
                <ion-radio-group [value]="workingSelectedValue()" (ionChange)="radioChange($event)">
                    @for (item of filteredItems; track item.value) {
                        <ion-item
                            [class.body-bold]="isChecked(item.value)"
                            [class.yellow]="isChecked(item.value)"
                            [class.body-medium]="!isChecked(item.value)"
                            style="--padding-start: 0; --inner-padding-end: 0; --background-activated-opacity: 0"
                        >
                            <ion-radio mode="ios" class="radio-custom" [value]="item.value">{{ item.text }}</ion-radio>
                        </ion-item>
                    }
                </ion-radio-group>
            </ion-list>
        </ion-content>
    </ng-template>
</ion-modal>
